import BaseDevice from '../base.js'
import Inner from './inner.js'
export default class DeviceImage extends BaseDevice {
   static render = (device, scale = 1) => {
      const baseWidth = STORAGE.getSetting('baseWidth', BASE_WIDTH)
      const MODS = device.width / baseWidth
      if (MODS < 2.5 || MODS > 4) return;

      return this.getDevice(device, scale, Inner.render(device.width));
   }

   static printCurrent(device, fontColor) {
      return `<text ${this.getFlip(device)} filter="url(#bg)" x="${device.flip ? "-" : ""}10px" y="${this.getTextPadding(device, 212)}" class="svgText" dominant-baseline="middle" text-anchor="left" fill="${fontColor}" stroke="${fontColor}">${device.current ? device.current + "A" : ""}</text>`;
   }

   static printText(device, fontColor, text) {
      return `<text ${this.getFlip(device)} filter="url(#bg)" x="${device.flip ? "-" : ""}10px" y="${this.getTextPadding(device, 102)}" class="svgText" dominant-baseline="middle" text-anchor="left" fill="${fontColor}" stroke="${fontColor}">${text}</text>`
   }
}
